import {
  Card,
  CardHeader,
  Chip,
  createStyles,
  Grid,
  makeStyles,
} from '@material-ui/core';
import { DateTime } from 'luxon';
import React from 'react';
import styled from 'styled-components';

import useMaintenanceActions from 'core/hooks/useMaintenanceActions';
import { useSchemaMeta } from 'Elements/Form/Schema';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';

import ActionPhoto from './ActionPhoto';

const Row = styled(GridRow)`
  grid-template-columns: 100px 250px minmax(250px, 1fr) 100px;
`;

const useStyles = makeStyles(theme =>
  createStyles({
    chip: {
      margin: '2px'
    }
  })
);

export default function MaintenanceActionsTable() {
  const classes = useStyles();
  const { maintenanceId } = useSchemaMeta<{ maintenanceId: number }>();
  const actions = useMaintenanceActions(maintenanceId);

  return (
    <Card elevation={1}>
      <CardHeader title="Toimenpiteet" />
      <GridTable>
        <Header>
          <Row>
            <Column>Paikka</Column>
            <Column>Toimenpide</Column>
            <Column>Palvelut</Column>
            <Column>Pvm</Column>
          </Row>
        </Header>
        <Body>
          {actions.map(action => (
            <Row key={action.id}>
              <Column>{action.slot}</Column>
              <Column>
                {action.textual}{' '}
                {action.description && (
                  <small>
                    <br />
                    {action.description}
                  </small>
                )}
                {action.photos && (
                  <Grid container>
                    {action.photos.map((photo, index) => (
                      <Grid item xs>
                        <ActionPhoto photo={photo} key={index} />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Column>
              <Column>
                {action.services.map((service, index) => (
                  <Chip
                    key={index}
                    color="primary"
                    className={classes.chip}
                    label={service.title}
                  ></Chip>
                ))}
              </Column>
              <Column>
                {DateTime.fromSQL(action.created_at).toFormat('dd.MM.yyyy')}
              </Column>
            </Row>
          ))}
        </Body>
      </GridTable>
    </Card>
  );
}
